<template>
  <footer class="app-footer no-print">
    <div class="footer-wrap">
      <div class="footer-logo">
        <a href="https://asokoinsight.com" aria-label="Asoko Insight Logo">
          <asoko-logo-transparent />
        </a>
        <app-copyright />
      </div>

      <div class="footer-content">
        <div class="footer-blocks">
          <div class="footer-block first-block">
            <h6>About Us</h6>
            <p>
              Asoko Insight is Africa's leading corporate data and engagement platform, providing global investors, multinationals and development institutions the most effective route to discover, shortlist and engage their target universe of African companies.
            </p>
            <router-link to="/about/team" class="link-details">
              Read More
            </router-link>

            <div class="inner-block">
              <h6>Press</h6>
              <router-link to="/insights/developments" class="link-details">
                Corporate news
              </router-link>
            </div>
          </div>

          <div class="footer-block narrow-block">
            <h6>Our Offices</h6>
            <p>
              <a
                href="https://goo.gl/maps/A4k7JqNW2ETWo7449"
                target="_blank"
                rel="noopener"
                @click="trackOurOfficesClick"
                >London, UK</a
              >
            </p>
          </div>

          <div class="footer-block">
            <h6>Contacts</h6>
            <div class="contact-item">
              <p>General Enquiries</p>
              <p>
                <a
                  href="mailto:info@asokoinsight.com"
                  @click="trackContactsClick"
                  >info@asokoinsight.com</a
                >
              </p>
            </div>
            <div class="contact-item">
              <p>News Enquiries</p>
              <p>
                <a
                  href="mailto:editorial@asokoinsight.com"
                  @click="trackContactsClick"
                  >editorial@asokoinsight.com</a
                >
              </p>
            </div>
            <div class="contact-item">
              <p>Custom Sales Enquiries</p>
              <p>
                <a
                  href="mailto:sales@asokoinsight.com"
                  @click="trackContactsClick"
                  >sales@asokoinsight.com</a
                >
              </p>
            </div>
          </div>
        </div>

        <hr />

        <div class="footer-blocks">
          <div class="footer-block first-block">
            <h6>Careers</h6>
            <p>
              Asoko is growing fast and has exciting apportunities in multiple
              locations.
            </p>
            <router-link to="/about/careers" class="link-details"
              >See Current Openings</router-link
            >
          </div>

          <div class="footer-block split-block">
            <div class="split-child social-block narrow-block">
              <h6>Follow Us</h6>
              <a
                target="_blank"
                href="https://www.facebook.com/asokoinsight"
                aria-label="Asoko Insight Facebook"
                rel="noopener"
              >
                <facebook-icon />
              </a>
              <a
                target="_blank"
                href="https://twitter.com/AsokoInsight"
                aria-label="Asoko Insight Twitter"
                rel="noopener"
              >
                <twitter-icon />
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/asoko-insight"
                aria-label="Asoko Insight Linkedin"
                rel="noopener"
              >
                <linkedin-icon />
              </a>
            </div>

          </div>

        </div>
      </div>
    </div>

    <img
      height="1"
      width="1"
      style="display:none;"
      alt=""
      src="https://px.ads.linkedin.com/collect/?pid=2807145&fmt=gif"
    />
  </footer>
</template>

<script>
import AppCopyright from 'components/home/home-copyright'
import asokoLogoTransparent from 'assets/images/logos/asoko-logo-transparent.svg?inline'
import facebookIcon from 'assets/images/icons/facebook-material-icon.svg?inline'
import linkedinIcon from 'assets/images/icons/linkedin-material-icon.svg?inline'
import twitterIcon from 'assets/images/icons/twitter-material-icon.svg?inline'

export default {
  name: 'app-footer',
  components: {
    AppCopyright,
    asokoLogoTransparent,
    facebookIcon,
    linkedinIcon,
    twitterIcon,
  },
  computed: {
    userId() {
      return this.$store.state.user.currentUser.userId || 'guest'
    },
  },
  methods: {
    trackOurOfficesClick() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-our-offices',
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event('click-our-offices', {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
      return true
    },
    trackContactsClick() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-contacts',
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event('click-contacts', {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.app-footer {
  background: #0e1b30;
  padding: $padding-l;
  font-size: $footer-font;
  color: $font-on-dark-color;
  a {
    color: $link-dark-color;
    &:hover {
      color: $link-dark-hover-color;
    }
  }
  hr {
    opacity: 0.25;
    margin-right: $margin-l;
  }
  .link-details {
    text-transform: uppercase;
    display: inline-block;
    margin-top: $margin-m;
  }
  .inner-block {
    .link-details {
      margin-top: 0px;
    }
  }
}
.footer-wrap {
  display: flex;
  flex-direction: column;
  @include desktop {
    flex-direction: row;
  }
  @include desktop-wide {
    margin: $margin-m $margin-xl;
  }
}
.footer-logo {
  min-width: 250px;
  margin-right: $margin-l;
  margin-bottom: $margin-l;
  a {
    display: inline-block;
    margin-bottom: $margin-m;
  }
  svg {
    height: 35px;
    width: 172px;
    fill: #fff;
  }
}
.footer-blocks {
  display: flex;
  flex-direction: column;
  @include desktop {
    flex-direction: row;
  }
}
.footer-block {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 200px;
  margin-bottom: $margin-xl;
  @include desktop {
    margin-right: $margin-l;
    margin-bottom: 0px;
  }
  h6 {
    font-size: $header-size-7;
    text-transform: uppercase;
    color: $header-secondary-color;
    margin-bottom: $margin-m;
  }
  p {
    margin-bottom: 0px;
  }
}
.inner-block {
  margin-top: $margin-l;
}
.narrow-block {
  @include desktop {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 170px;
  }
  @include desktop-wide {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 250px;
  }
}
.first-block {
  @include desktop {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 200px;
  }
  @include desktop-wide {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 270px;
  }
}
.split-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @include desktop {
    flex-direction: row;
  }
}
.contact-item {
  margin-bottom: $margin-m;
}
.social-block {
  a {
    display: inline-block;
    margin-right: $margin-s;
    margin-top: $margin-s + $margin-xs;
  }
  svg {
    @extend %icon-small;
    fill: #fff;
  }
}
.remote-locations {
  margin-top: $margin-s;
  .locations-subheader {
    margin-bottom: $margin-s;
    color: $font-on-dark-color;
  }
  p {
    color: $link-dark-color;
  }
}
</style>
